import { defineDebugSection } from "../defineDebugSection";
import EnvironmentFooter from "./EnvironmentFooter.vue";
import EnvironmentSection from "./EnvironmentSection.vue";

/** Omgeving: debug mode, presets and addresses. In every app; the login app shows only this section. */
export const environmentSection = defineDebugSection({
  id: "environment",
  label: "debug_tools.sections.environment",
  icon: "server",
  component: EnvironmentSection,
  footer: EnvironmentFooter,
  order: 10,
});
